import React, { useState, useContext, useEffect } from 'react'
// make sure to use https
export const url = `https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}`
const AppContext = React.createContext()

const AppProvider = ({ children }) => {
  const [isLoading,setIsLoading]=useState(true);
  const [error,setError]=useState({show:false,msg:''})
  const [movies,setMovies]=useState([]);
  const [query,setQuery]=useState('Spider-Man');

  const fetchMovies=async (url)=>{
    setIsLoading(true);
    try {
      const res=await fetch(url);
      const data=await res.json();
      if(data.Response==='True')
      {
        setMovies(data.Search);
        setError({show:false,msg:''});
      }
      else{
        setError({show:true,msg:data.Error})
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(()=>{
    fetchMovies(`${url}&s=${query}`)
  },[query])
  return <AppContext.Provider value={{isLoading,query,error,movies,setQuery}}>{children}</AppContext.Provider>
}
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext)
}

export { AppContext, AppProvider }
